// Configuração de coordenadas para preenchimento do PDF
// Ajuste estes valores conforme necessário para posicionar corretamente os textos

export const coordenadasPDF = {
  // Informações da proposta
  proposta_numero: { x: 270, y: 1658, page: 1 },
  data: { x: 630, y: 1658, page: 1 },
  id_projeto: { x: 1050, y: 1658, page: 1 },
  
  // Dados do cliente
  nome_cliente: { x: 345, y: 1515, page: 1 },
  cpf_cnpj: { x: 235, y: 1460, page: 1 },
  endereco: { x: 240, y: 1405, page: 1 },
  cidade_estado: { x: 295, y: 1350, page: 1 },
  cep: { x: 180, y: 1295, page: 1 },
  telefone: { x: 220, y: 1240, page: 1 },
  email: { x: 200, y: 1185, page: 1 },
  
  // Especificações técnicas
  qtd_modulos: { x: 285, y: 1040, page: 1 },
  marca_paineis: { x: 570, y: 1040, page: 1 },
  potencia: { x: 980, y: 1040, page: 1 },
  potencia_total: { x: 290, y: 982, page: 1 },
  tipo_instalacao: { x: 322, y: 930, page: 1 },
  qtd_inversores: { x: 290, y: 875, page: 1 },
  marca_inversores: { x: 570, y: 875, page: 1 },
  modelo_inversores: { x: 980, y: 875, page: 1 },
  
  // Plano de proteção
  tipo_plano: { x: 180, y: 710, page: 1 },
  vigencia: { x: 215, y: 655, page: 1 },
  
  // Detalhamento de valores
  qtd_modulos_valores: { x: 290, y: 1570, page: 2 },
  valor_total: { x: 815, y: 1468, page: 2 },
  forma_pagamento: { x: 365, y: 1252, page: 2 },

  // Observações (caixa branca abaixo de Forma de Pagamento — página 2)
  // y = baseline da 1ª linha; maxWidth/maxLines limitam o texto ao espaço do box
  observacoes: {
    x: 110,
    y: 1085,
    page: 2,
    maxWidth: 1140,
    maxLines: 7,
    fontSize: 13,
    lineHeight: 18,
  },
  
  // Aceite da proposta (página 2)
  nome_cliente_assinatura: { x: 550, y: 485, page: 2 },
  cpf_cnpj_assinatura: { x: 740, y: 388, page: 2 },
  local_data: { x: 568, y: 300, page: 2 }
};

/** Limite sugerido no formulário para caber na caixa do PDF (~7 linhas). */
export const MAX_OBSERVACOES_PROPOSTA = 450;

// Instruções para ajustar coordenadas:
// 1. Abra o arquivo ajustar-coordenadas-pdf.html no navegador
// 2. Clique em "Gerar PDF com Texto de Teste"
// 3. Baixe o PDF e verifique onde cada texto aparece
// 4. Use os botões "Ajustar" para modificar as coordenadas
// 5. Copie as coordenadas corretas para este arquivo
// 6. Teste novamente até ficar perfeito

// Exemplo de como ajustar:
// Se o texto "João Silva Teste" aparecer muito à direita, diminua o valor X
// Se aparecer muito acima, diminua o valor Y
// Se aparecer muito abaixo, aumente o valor Y

